import { withViewModel } from '../../../../../../../../infrastructure/components/with-view-model';
import { ConnectionZoomWebinarFormPresentation } from './connection-zoom-webinar-form.presentation';
import { ConnectionZoomWebinarFormVM } from './connection-zoom-webinar-form.viewmodel';
import { TConnection } from '../../../../../../../../api/blueprints/connection.template.types';
import { ConnectionVersion } from '../../../../../../../../constants/common.constants';

type ConnectionZoomWebinarTemplateFormProps = {
    connection: TConnection;
    isAutoSyncLimitReached: boolean;
    addConnection: (connection: TConnection) => void;
    editConnection: (connection: TConnection) => void;
    connectionVersion: ConnectionVersion;
};

export const ConnectionZoomWebinarTemplateForm = withViewModel(ConnectionZoomWebinarFormPresentation, (props: ConnectionZoomWebinarTemplateFormProps) => {
    const vm = new ConnectionZoomWebinarFormVM(
        props.connection, props.addConnection, props.editConnection, props.isAutoSyncLimitReached, props.connectionVersion
    );

    return vm;
});
